export const ADD_QUIZ_WITH_REPLIES = 'app/quiz/set/add_quiz';
export const REMOVE_FORMATION_QUIZZES = 'app/quiz/set/REMOVE_FORMATION_QUIZZES';
export const CLEAR_STATE = 'app/quiz/set/clear_state';
